import netsAgentStatus from './nets-agent-status';

export default angular
  .module('app.agent-status', [])
  .component('netsAgentStatus', netsAgentStatus);
